// extracted by mini-css-extract-plugin
module.exports = {"balloon":"a10a3f92e9--balloon--pg12B","icon":"a10a3f92e9--icon--L8Dnj"};